<template>
  <div class="articleContent">
    <div class="ArticalSection mt-8">
      <div>
        <span class="h1">{{ Data.Title }}</span>
      </div>
      <div class="d-flex justify-space-between mt-8">
        <div class="d-flex align-center">
          <div>
            <v-avatar>
              <img v-if="Data.SubmittedByProfileImage" :src="concatBaseUrl(Data.SubmittedByProfileImage)" alt="John" />
              <img v-if="Data.SubmittedByProfileImage == null || Data.SubmittedByProfileImage.endsWith(null)" src="https://www.freeiconspng.com/thumbs/profile-icon-png/profile-icon-1.png" alt="John" />
            </v-avatar>
          </div>
          <div class="span1">  {{ Data.SubmittedByName }}</div>
          <div class="span2 ml-6">
            Last updated: {{
              Data.CreatedDate != undefined ? formatDate(Data.CreatedDate) : ''
            }}
          </div>
        </div>
        <div class="d-flex">
          <div>
            <svg
              width="21"
              height="19"
              viewBox="0 0 21 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M19.1195 2.50827L20.5343 2.67349L19.8983 3.948C19.5882 4.56953 19.2778 5.19105 18.967 5.81258C18.9302 5.94422 18.8654 6.05962 18.7697 6.20987C18.7296 6.27265 18.5929 6.47236 18.5865 6.48194C18.5504 6.53608 18.5237 6.57878 18.5045 6.61299V9.00152C18.5045 15.1135 12.5895 18.9974 7.00354 18.9974C5.86051 18.9974 4.99207 18.9427 3.99765 18.7257C2.36115 18.3685 1.14327 17.6587 0.585973 16.418L0.0122107 15.1407L1.40659 15.0124C2.66801 14.8964 3.76169 14.6561 4.60159 14.3343C2.29577 13.9635 1.0036 12.9508 1.0036 11.0489V10.0489H2.0036C2.22331 10.0489 2.42143 10.0311 2.59854 9.99834C0.868001 8.96365 0.00122175 7.30379 0.00122175 5.00152C0.00103266 4.9034 0.00103266 4.90339 0.000442551 4.79847C-0.00605857 3.63803 0.0562722 3.01797 0.373948 2.22659C0.577543 1.71941 0.871831 1.24988 1.2679 0.819668L2.02251 0L2.75617 0.838468C5.17394 3.60161 7.56395 5.27795 10.0042 5.48072C10.0146 2.93105 11.9415 1.00152 14.5043 1.00152C15.6991 1.00152 16.7828 1.45501 17.6345 2.27273C18.1006 2.36851 18.5957 2.44709 19.1195 2.50827ZM16.9086 4.16202L16.6021 4.0926L16.3904 3.86028C15.8785 3.29855 15.2359 3.00152 14.5043 3.00152C13.0414 3.00152 12.0041 4.04391 12.0041 5.50152C12.0041 5.73974 11.998 5.88942 11.9683 6.08615C11.8499 6.87116 11.4096 7.50152 10.5041 7.50152C7.50607 7.50152 4.80136 5.89542 2.16389 3.15228C2.02792 3.56561 1.99595 3.99047 2.00041 4.78727C2.00101 4.89384 2.00101 4.89384 2.00122 5.00152C2.00122 7.04953 2.83093 8.16977 4.79547 8.79419L5.49255 9.01575V9.7472C5.49255 10.6342 4.65222 11.4691 3.42268 11.8431C3.98631 12.2708 5.139 12.5015 7.00389 12.5015H8.00389V13.5015C8.00389 14.9343 6.35762 16.0561 3.87075 16.6419C4.68178 16.8903 5.76166 16.9974 7.00354 16.9974C11.618 16.9974 16.5045 13.7888 16.5045 9.00152V6.50152C16.5045 6.20774 16.5897 5.95273 16.7311 5.68759C16.7865 5.58393 16.8474 5.48509 16.9225 5.37237C16.9367 5.35115 16.9892 5.27426 17.0309 5.21279L17.1101 5.05429C17.2386 4.79745 17.3669 4.54061 17.4952 4.28377C17.2958 4.24599 17.1003 4.20541 16.9086 4.16202Z"
                fill="#333333"
              />
            </svg>
          </div>
          <div class="ml-4">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2 0H18C19.1046 0 20 0.89543 20 2V18C20 19.1046 19.1046 20 18 20H2C0.89543 20 0 19.1046 0 18V2C0 0.89543 0.89543 0 2 0ZM2 2V18H18V2H2ZM9.13306 10.0044H11V16H13V10.0044H14.9824V8.00439H13V7C13 6.44772 13.4477 6 14 6H15V4H14C12.3431 4 11 5.34315 11 7V8.00439H9.13306V10.0044Z"
                fill="#333333"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="">
        <v-row >
          <v-col cols="12">
            <v-card
              class="d-flex justify-content-center align-items-center display-img"
              flat
            >
              <v-img 
              contain 
              :src="DisplayImg"
              ></v-img>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
    <div flat v-html="previewBlogContent"></div>
  </div>
</template>

<script>
export default {
  name: "ArticalSectionComponent",
  props: ["Data"],
  data() {
    return {
      property: "value",
    };
  },
  computed: {
    DisplayImg() {
      if (this.Data.Banner == undefined) {
        return;
      }
      if (typeof this.Data.Banner == "string") {
        return this.Data.Banner;
      } else {
        var reader = new FileReader();
        reader.onload = () => {
          this.property = reader.result;
        };

        reader.readAsDataURL(this.Data.Banner);
      }
      return this.property;
    },
    // previewBlogContent() {
    //   return this.processContentWithImageClass();
    // },
    previewBlogContent() {
      const descriptionWithClass = this.processContentWithImageClass(this.Data.Description);
      const contentWithClass = this.processContentWithImageClass(this.Data.Content);
      
      return `${descriptionWithClass} ${contentWithClass}`;
    },
  },
  methods: {
    formatDate(inputDate) {
      const date = new Date(inputDate);
      const options = { year: 'numeric', month: 'short', day: 'numeric' };
      return date.toLocaleDateString('en-US', options);
    },
    concatBaseUrl(url) {
      // return process.env.VUE_APP_IMG_URL + url;
      return url;
    },
    // processContentWithImageClass() {
    //   // Check if the Data.Content contains any image tags
    //   const hasImages = /<img[\s\S]*?>/.test(this.Data.Description);

    //   if (hasImages) {
    //     // If images are present, apply the image-responsive class
    //     return this.Data.Description.replace(
    //       /<img/g,
    //       '<img class="blogPreviewContentWrapperImg"'
    //     );
    //   } else {
    //     // If no images are present, return the original content
    //     return this.Data.Description;
    //   }
    // },

    processContentWithImageClass(content) {
      const hasImages = /<img[\s\S]*?>/.test(content);

      if (hasImages) {
        return content.replace(
          /<img/g,
          '<img class="blogPreviewContentWrapperImg"'
        );
      } else {
        return content;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.articleContent {
  width: 100%;
  max-width: 785px;
  margin: auto;
}
.ArticalSection {
  .h1 {
    font-family: "Noto Serif";
    font-size: 44px;
    font-weight: 700;
  }

  .span1 {
    font-family: "DM Sans";
    font-size: 16px;
    font-weight: 500;
  }

  .span2 {
    font-family: "DM Sans";
    font-size: 14px;
    font-weight: 400;
    color: rgba(34, 34, 34, 0.7);
  }

  .span3 {
    font-family: "DM Sans";
    font-size: 16px;
    font-weight: 400;
    color: rgba(34, 34, 34, 0.7);
  }

  .detail_one {
    font-family: "DM Sans";
    font-size: 20px;
  }

  .h2 {
    font-family: "DM Sans";
    font-size: 34px;
    font-weight: 400;
  }

  .h3 {
    font-family: "DM Sans";
    font-size: 24px;
    font-weight: 400;
  }

  img {
    width: 100%;
  }
  .display-img{
    width: 785px; height: auto; margin: 16px 0;
  }
}
</style>
